import React from "react";
import { Switch, Route, Redirect } from "react-router-dom";
// creates a beautiful scrollar
import PerfectScrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import {  DateRange, Bookmarks, ExitToApp, CalendarToday  } from "@material-ui/icons/";
// core components
import Navbar from "components/Navbars/Navbar.js";
import Footer from "components/Footer/Footer.js";
import Sidebar from "components/Sidebar/Sidebar.js";
import FixedPlugin from "components/FixedPlugin/FixedPlugin.js";
import styles from "assets/jss/material-dashboard-react/layouts/adminStyle.js";
import LibraryBooks from "@material-ui/icons/LibraryBooks";
import bgImage from "assets/img/sidebar-2.jpg";
import logo from "assets/img/logo2.png";

import Info from "views/Asset/Info.js";
import AssetList from "views/Asset/AssetList";
import BrandList from "views/Asset/BrandList";
import CompanyList from "views/Asset/CompanyList";
import AssetTypeList from "views/Asset/AssetTypeList";
import CategoryList from "views/Asset/CategoryList";
import PlaceList from "views/Asset/PlaceList";
import AssetBorrowList from "views/Asset/AssetBorrowList";


import LogoutPage from "views/UserProfile/LogoutPage.js";
import { Assignment } from "@material-ui/icons/";

let ps;

const routes = [
    {
      name: "รายการครุภัณฑ์",
      icon: DateRange,
      component: AssetList,
      layout: "/asset",
      path: "/index",
    },
    {
      name: "ยืม-คืนครุภัณฑ์",
      icon: LibraryBooks,
      component: AssetBorrowList,
      layout: "/asset",
      path: "/borrow"
    },
    {
        name: "ประเภทครุภัณฑ์",
        icon: Bookmarks,
        component: AssetTypeList,
        layout: "/asset",
        path: "/assettype",
    },
    {
        name: "หมวดครุภัณฑ์",
        icon: Bookmarks,
        component: CategoryList,
        layout: "/asset",
        path: "/category",
    },
    {
        name: "ยี่ห้อ",
        icon: Bookmarks,
        component: BrandList,
        layout: "/asset",
        path: "/brand",
    },
    {
        name: "ผู้ขาย",
        icon: Bookmarks,
        component: CompanyList,
        layout: "/asset",
        path: "/company",
    },
    {
        name: "สถานที่",
        icon: Bookmarks,
        component: PlaceList,
        layout: "/asset",
        path: "/place",
    },
];

const switchRoutes = (
    <Switch>

    {routes.map((prop, key) => {
     
        return (
          <Route
            path={prop.layout + prop.path}
            component={prop.component}
            key={key}
          />
        );
      
      return null;
    })}

    <Redirect from="/asset" to="/asset/index" />
  </Switch>
);

const useStyles = makeStyles(styles);

export default function Asset({ ...rest }) {
  // styles
  const classes = useStyles();
  // ref to help us initialize PerfectScrollbar on windows devices
  const mainPanel = React.createRef();
  // states and functions
  const [image, setImage] = React.useState(bgImage);
  const [color, setColor] = React.useState("blue");
  const [fixedClasses, setFixedClasses] = React.useState("dropdown show");
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const handleImageClick = image => {
    setImage(image);
  };
  const handleColorClick = color => {
    setColor(color);
  };
  const handleFixedClick = () => {
    if (fixedClasses === "dropdown") {
      setFixedClasses("dropdown show");
    } else {
      setFixedClasses("dropdown");
    }
  };
  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };
  const getRoute = () => {
    return window.location.pathname !== "/admin/maps";
  };
  const resizeFunction = () => {
    if (window.innerWidth >= 960) {
      setMobileOpen(false);
    }
  };
  // initialize and destroy the PerfectScrollbar plugin
  React.useEffect(() => {
    if (navigator.platform.indexOf("Win") > -1) {
      ps = new PerfectScrollbar(mainPanel.current, {
        suppressScrollX: true,
        suppressScrollY: false
      });
      document.body.style.overflow = "hidden";
    }
    window.addEventListener("resize", resizeFunction);
    // Specify how to clean up after this effect:
    return function cleanup() {
      if (navigator.platform.indexOf("Win") > -1) {
        ps.destroy();
      }
      window.removeEventListener("resize", resizeFunction);
    };
  }, [mainPanel]);
  return (
    <div className={classes.wrapper}>
      <Sidebar
        routes={routes}
        logoText={"ระบบครุภัณฑ์"}
        logo={logo}
        image={image}
        handleDrawerToggle={handleDrawerToggle}
        open={mobileOpen}
        color={color}
        {...rest}
      />
      <div className={classes.mainPanel} ref={mainPanel}>
        <Navbar
          routes={routes}
          handleDrawerToggle={handleDrawerToggle}
          {...rest}
        />
        {/* On the /maps route we want the map to be on full screen - this is not possible if the content and conatiner classes are present because they have some paddings which would make the map smaller */}
        {getRoute() ? (
          <div className={classes.content}>
            <div className={classes.container}>{switchRoutes}</div>
          </div>
        ) : (
          <div className={classes.map}>{switchRoutes}</div>
        )}
        {getRoute() ? <Footer /> : null}
        {/* <FixedPlugin
          handleImageClick={handleImageClick}
          handleColorClick={handleColorClick}
          bgColor={color}
          bgImage={image}
          handleFixedClick={handleFixedClick}
          fixedClasses={fixedClasses}
        /> */}
      </div>
    </div>
  );
}
